module.exports = __webpack_public_path__ + "static/Certified_B_Corporation_B_Corp_Logo_2022_Black_RGB-c9ded598611d609acc4d8cafda7ede00.svg";